import faker from 'faker';

const StatusAM = [
  {
    name: 'Criada',
    data: [{ x: 0, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Autorizada',
    data: [{ x: 1, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Pendente',
    data: [{ x: 2, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Erro',
    data: [{ x: 3, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando pagamento de parcela(s)',
    data: [{ x: 4, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Paga',
    visible: false,
    data: [{ x: 5, y: faker.random.number({ min: 10, max: 500 }) }],
  }
];

export default StatusAM;